import { InjectionToken } from '@angular/core';
import type { Extent } from 'ol/extent';

/** Optional per-app OGC collection ID for the "Open Series" basemap tile layer in Canvas home (map view). */
export const OGC_TILES_COLLECTION_ID = new InjectionToken<string>('OGC_TILES_COLLECTION_ID');

/** Optional per-app OGC resource server URLs used to filter datasets in the maps canvas modal. */
export const OGC_MAPS_RESOURCE_SERVER_URLS = new InjectionToken<string[]>(
  'OGC_MAPS_RESOURCE_SERVER_URLS',
);

/** Builds the dataset detail page URL for a catalogue item id (default: `/dataset/:id`). */
export const CANVAS_DATASET_DETAIL_URL = new InjectionToken<(datasetId: string) => string>(
  'CANVAS_DATASET_DETAIL_URL',
);

/** Optional per-app RS resource server URLs used to filter datasets in the charts canvas modal. */
export const CHARTS_RESOURCE_SERVER_URLS = new InjectionToken<string[]>(
  'CHARTS_RESOURCE_SERVER_URLS',
);

/** Optional app-provided toast notifications for canvas flows (e.g. request access). */
export interface CanvasNotifier {
  success(message: string): void;
  error(message: string): void;
}

export const CANVAS_NOTIFIER = new InjectionToken<CanvasNotifier>('CANVAS_NOTIFIER');

/**
 * Full browser URL to the project-specific boundary GeoJSON file served by the consuming app.
 *
 * Each app that uses the canvas lib must provide this token so the map can draw the
 * administrative boundary overlay and the basic-light/dark basemaps.  The canvas lib has
 * no default — if the token is omitted, boundary layers are silently skipped and a
 * console warning is emitted.
 *
 * @example
 * // In app.config.ts providers:
 * { provide: CANVAS_BOUNDARY_GEOJSON_URL, useValue: '/assets/my-region/boundary.geojson' }
 */
export const CANVAS_BOUNDARY_GEOJSON_URL = new InjectionToken<string>('CANVAS_BOUNDARY_GEOJSON_URL');

/**
 * Optional map extent (EPSG:4326) for initial center and boundary fit.
 * Defaults to Maharashtra when omitted (MahaAgX). IUDX should provide `INDIA_MAP_EXTENT`.
 */
export const CANVAS_MAP_EXTENT = new InjectionToken<Extent>('CANVAS_MAP_EXTENT');
